import { render, staticRenderFns } from "./ZKanban.vue?vue&type=template&id=3cccbd34&scoped=true&"
import script from "./ZKanban.vue?vue&type=script&lang=js&"
export * from "./ZKanban.vue?vue&type=script&lang=js&"
import style0 from "./ZKanban.vue?vue&type=style&index=0&id=3cccbd34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cccbd34",
  null
  
)

export default component.exports